import { StyleSheet } from "@react-pdf/renderer";

const actaStyles = StyleSheet.create({
  page: {
    paddingTop: 30,
    paddingHorizontal: 36,
    paddingBottom: 70,
    fontSize: 9,
    fontFamily: "Helvetica",
    color: "#1a1a1a"
  },
  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 6
  },
  headerTextBlock: {
    flex: 1,
    paddingRight: 12
  },
  headerLogo: {
    width: 95,
    objectFit: "contain"
  },
  headerTitulo: {
    fontSize: 8,
    fontWeight: 700
  },
  footer: {
    position: "absolute",
    bottom: 18,
    left: 36,
    right: 36,
    borderTopWidth: 0.5,
    borderTopColor: "#cccccc",
    paddingTop: 6
  },
  footerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },
  footerLogoCampo: {
    width: 50,
    objectFit: "contain"
  },
  footerLogoConvenio: {
    width: 260,
    objectFit: "contain"
  },
  tituloCentral: {
    fontSize: 11,
    fontWeight: 700,
    textAlign: "center",
    marginTop: 4
  },
  subtitulo: {
    fontSize: 9,
    textAlign: "center",
    marginTop: 2,
    marginBottom: 2
  },
  actaTitulo: {
    fontSize: 10,
    fontWeight: 700,
    textAlign: "center",
    marginTop: 8,
    marginBottom: 10,
    textTransform: "uppercase"
  },
  infoTable: {
    borderWidth: 1,
    borderColor: "#000",
    marginBottom: 12
  },
  infoRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000"
  },
  infoRowLast: {
    flexDirection: "row"
  },
  infoLabel: {
    width: "35%",
    padding: 4,
    fontWeight: 700,
    borderRightWidth: 1,
    borderRightColor: "#000",
    backgroundColor: "#f2f2f2"
  },
  infoValue: {
    width: "65%",
    padding: 4
  },
  seccionTitulo: {
    fontSize: 9,
    fontWeight: 700,
    marginTop: 8,
    marginBottom: 4
  },
  parrafo: {
    fontSize: 8.5,
    lineHeight: 1.4,
    textAlign: "justify",
    marginBottom: 6
  },
  bienesTable: {
    borderWidth: 1,
    borderColor: "#000",
    marginTop: 4,
    marginBottom: 10
  },
  bienesHeaderRow: {
    flexDirection: "row",
    backgroundColor: "#e6e6e6",
    borderBottomWidth: 1,
    borderBottomColor: "#000"
  },
  bienesRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000"
  },
  bienesCellNo: { width: "6%", padding: 3, borderRightWidth: 1, borderRightColor: "#000", fontWeight: 700 },
  bienesCellBien: { width: "20%", padding: 3, borderRightWidth: 1, borderRightColor: "#000", fontWeight: 700 },
  bienesCellSerial: { width: "12%", padding: 3, borderRightWidth: 1, borderRightColor: "#000", fontWeight: 700 },
  bienesCellCantidad: { width: "10%", padding: 3, borderRightWidth: 1, borderRightColor: "#000", fontWeight: 700, textAlign: "center" },
  bienesCellDescripcion: { width: "38%", padding: 3, borderRightWidth: 1, borderRightColor: "#000", fontWeight: 700 },
  bienesCellObs: { width: "14%", padding: 3, fontWeight: 700 },
  clausulasLista: {
    marginBottom: 6
  },
  clausulaItem: {
    flexDirection: "row",
    marginBottom: 3
  },
  clausulaLetra: {
    width: 14,
    fontSize: 8.5
  },
  clausulaTexto: {
    flex: 1,
    fontSize: 8.5,
    lineHeight: 1.4,
    textAlign: "justify"
  },
  firmasRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 40
  },
  firmaBox: {
    width: "30%",
    borderTopWidth: 1,
    borderTopColor: "#000",
    paddingTop: 4
  },
  firmaLabel: {
    fontSize: 8,
    fontWeight: 700
  },
  firmaTexto: {
    fontSize: 8
  }
});

export default actaStyles;
